import { useSelector, useDispatch } from 'react-redux';
import { useMemo, useCallback } from 'react';
import {
    selectRestaurants,
    selectRestaurantsLoaded,
    selectSelectedRestaurantId,
    selectSelectedRestaurant,
} from '../store/slices/restaurantSlice';
import {
    setRestaurants as setRestaurantsAction,
    setSelectedRestaurantId as setSelectedRestaurantIdAction,
} from '../store/slices/restaurantSlice';

// useRestaurant hook - maintains same API as RestaurantContext
export const useRestaurant = () => {
    const dispatch = useDispatch();
    const restaurants = useSelector(selectRestaurants);
    const restaurantsLoaded = useSelector(selectRestaurantsLoaded);
    const selectedRestaurantId = useSelector(selectSelectedRestaurantId);
    const selectedRestaurant = useSelector(selectSelectedRestaurant);

    const setRestaurants = useCallback((restaurants) => {
        dispatch(setRestaurantsAction(restaurants));
    }, [dispatch]);

    const setSelectedRestaurantId = useCallback((id) => {
        dispatch(setSelectedRestaurantIdAction(id));
    }, [dispatch]);

    return useMemo(() => ({
        restaurants,
        restaurantsLoaded,
        selectedRestaurantId,
        selectedRestaurant,
        setRestaurants,
        setSelectedRestaurantId,
    }), [restaurants, restaurantsLoaded, selectedRestaurantId, selectedRestaurant, setRestaurants, setSelectedRestaurantId]);
};

export default useRestaurant;

